// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__JNJQG","options":"AnswerScale_options__25iDm","selected":"AnswerScale_selected__1bDVz"};